import { SettingsState } from '@/types/settings';

export function loadSettingsFromStorage(): Partial<SettingsState> | null {
  try {
    const stored = localStorage.getItem('app-settings');
    if (stored) {
      return JSON.parse(stored);
    }
    return null;
  } catch (error) {
    console.warn('Failed to load settings from localStorage:', error);
    return null;
  }
}

export function saveSettingsToStorage(settings: Partial<SettingsState>): void {
  try {
    localStorage.setItem('app-settings', JSON.stringify(settings));
  } catch (error) {
    console.warn('Failed to save settings to localStorage:', error);
  }
}

export function clearSettingsFromStorage(): void {
  try {
    localStorage.removeItem('app-settings');
    localStorage.removeItem('setup-config');
  } catch (error) {
    console.warn('Failed to clear settings from localStorage:', error);
  }
}

export function calculateDataSize(): string {
  try {
    const setupConfig = localStorage.getItem('setup-config');
    const appSettings = localStorage.getItem('app-settings');
    
    let totalSize = 0;
    if (setupConfig) totalSize += setupConfig.length;
    if (appSettings) totalSize += appSettings.length;
    
    // Convert bytes to KB/MB
    if (totalSize < 1024) {
      return `${totalSize} bytes`;
    } else if (totalSize < 1024 * 1024) {
      return `${(totalSize / 1024).toFixed(1)} KB`;
    } else {
      return `${(totalSize / (1024 * 1024)).toFixed(1)} MB`;
    }
  } catch (error) {
    console.warn('Failed to calculate data size:', error);
    return '0 bytes';
  }
}

export function generateSessionId(): string {
  return Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
}

export function getOrCreateSessionId(): string {
  let sessionId = localStorage.getItem('session-id');
  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem('session-id', sessionId);
  }
  return sessionId;
}